import { useSelector, useDispatch } from 'react-redux';
import { getClients } from '../actions/clients';
import { dateToString, toTitleCase } from '../utils/functions';
import { listSelector } from '../selectors';
import useSmall from './useSmall';
import { clientsIndexName, customerType } from '../utils/variables';

const useClientData = ({ infiniteScroll = false } = {}) => {
  const dispatch = useDispatch();
  const isMobile = useSmall();
  const user = useSelector(state => state.auth.user);
  const usertype = useSelector(state => state.auth.usertype);
  const customerId = user?.customer?.id || '';
  const agentId = user?.agent?.id || '';
  const defaultOptions = useSelector(state =>
    listSelector.listOptions({ state, name: clientsIndexName, infiniteScroll }),
  );

  const alpha2 = useSelector(state => state?.locations?.yourLocation?.alpha2);

  return ({
    nextStartIndex,
    nextItemCount,
    nextScrollCount,
    actionIndex,
    infiniteScroll: primaryInfiniteScroll,
    isMobile: primaryIsMobile,
  }) => {
    let finalInfiniteScroll = false;
    if (primaryInfiniteScroll !== undefined) {
      finalInfiniteScroll = primaryInfiniteScroll;
    } else {
      finalInfiniteScroll = infiniteScroll;
    }

    let finalIsMobile = isMobile;
    if (primaryIsMobile !== undefined) {
      finalIsMobile = primaryIsMobile;
    } else {
      finalIsMobile = isMobile;
    }

    let newStart;
    if (nextStartIndex) {
      newStart = nextStartIndex;
    } else if (defaultOptions?.startIndex) {
      newStart = defaultOptions?.startIndex;
    } else if (defaultOptions?.startIndex === 0) {
      newStart = defaultOptions?.startIndex;
    }

    let newLimit;
    // console.log('nextItemCount: ', nextItemCount);
    // console.log('defaultOptions.itemCount: ', defaultOptions?.itemCount);
    if (nextItemCount) {
      newLimit = nextItemCount;
    } else if (defaultOptions?.itemCount) {
      newLimit = defaultOptions?.itemCount;
    } else if (defaultOptions?.itemCount === 0) {
      newLimit = defaultOptions?.itemCount;
    }

    const body = {
      customerId,
      agentId: agentId || undefined,
      usertype: usertype || customerType,
      limit: defaultOptions?.itemCount,
      offset: defaultOptions?.startIndex,
      fromDate: dateToString(defaultOptions?.startDate),
      toDate: dateToString(defaultOptions?.endDate),
      lob: toTitleCase(defaultOptions?.lob?.toString()), // defaultOptions?.lob,
      nextItemCount,
      nextScrollCount,
      nextStartIndex,
      scrollKey: defaultOptions?.scrollKey,
      staticLob: defaultOptions?.staticLob,
      infiniteScroll: finalInfiniteScroll,
      finalInfiniteScroll,
      isMobile: finalIsMobile,
      alpha2,
      search: defaultOptions?.search ? defaultOptions?.search : undefined,
      status: defaultOptions?.status ? defaultOptions?.status : undefined,
    };

    const params = {
      limit: newLimit,
      start: newStart,
      q: defaultOptions?.search ? defaultOptions?.search : undefined,
    };

    return dispatch(getClients.getClientsAction(params, body));
  };
};
export default useClientData;
